import React from 'react';
import { Drawer } from '@bedrock/components';
import withFunctionCall from '@mpc/common/src/utils/withFunctionCall';
import StatusProgressTab from './StatusProgressTab';

/** 状态进度抽屉 zIndex：悬浮于宿主详情抽屉之上 */
const STATUS_PROGRESS_Z_INDEX = 1001;

interface StatusProgressDrawerProps {
  visible: boolean;
  onClose: () => void;
  detailId?: number;
}

/**
 * "状态进度"悬浮抽屉。
 * 以 withFunctionCall 命令式包装：调用方 `StatusProgressDrawer.show({ detailId })` 即可打开，
 * visible/onClose 由 HOC 注入（onClose 指向销毁卸载），调用方无需维护开关 state。
 */
const StatusProgressDrawer: React.FC<StatusProgressDrawerProps> = ({ visible, onClose, detailId }) => (
  <Drawer
    title="状态进度"
    placement="right"
    visible={visible}
    destroyOnClose
    bodyScrolled
    onClose={onClose}
    width={1000}
    bodyStyle={{ padding: 0 }}
    zIndex={STATUS_PROGRESS_Z_INDEX}>
    <StatusProgressTab detailId={detailId} />
  </Drawer>
);

export default withFunctionCall(StatusProgressDrawer);
